import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import About from "./components/About";
import PropuestaDeValorSection from "./components/PropuestaDeValorSection";
import QuienSoySection from "./components/QuienSoySection";
import Testimonial from "./components/Testimonial";
import Interactive3DSection from "./components/Interactive3DSection";
import Footer from "./components/Footer";
import Copyright from "./components/Copyright";
import SuscripcionSection from "./components/SuscripcionSection";
import VideoSection from "./components/VideoSection";
import MiddleSection from "./components/MiddleSection";
import ContratarSection from "./components/ContratarSection";
import Empresas from "./components/Empresas";
import WhatsAppButton from "./components/WhatsAppButton";
import BlogErnesto from "./BlogErnesto";
import NewScreen from "./NewScreen";
import BlogPostPage from "./components/BlogPost/BlogPostPage";
import FaqIA from "./components/FaqIA";

// 🔹 Datos del evento Online
const ciudades = {
  miami: {
    nombre: "Online",
    fecha: "15 de Noviembre de 2025",
    modalidad: "Online",
    descripcion:
      "Evento online exclusivo desde plataforma virtual. Accede desde cualquier lugar y aprende con expertos.",
    imagen:
      "https://esgrymaconsulting.com/wp-content/uploads/2025/10/imagenia.png",
  },
};

const HomePage = () => {
  return (
    <div>
      <VideoSection />
      <MiddleSection />
      <About />
      <QuienSoySection />
      <PropuestaDeValorSection />
      <SuscripcionSection />
      <Empresas />
      <Interactive3DSection />
      <Testimonial />
      <ContratarSection />
      <FaqIA />
      <Footer />
      <Copyright />
      <WhatsAppButton />
    </div>
  );
};

const App = () => {
  const [showModal, setShowModal] = useState(false);
  const [ciudadSeleccionada, setCiudadSeleccionada] = useState("miami");

  // Evita el scroll del fondo cuando el modal está abierto
  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "auto";
  }, [showModal]);

  return (
    <div className="max-w-[1920px] mx-auto overflow-hidden bg-white">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Biografia" element={<NewScreen />} />
        <Route path="/blogernesto" element={<BlogErnesto />} />
        <Route path="/blog/post/:slug" element={<BlogPostPage />} />
      </Routes>

      {/* Botón flotante inferior izquierdo */}
      <div className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-50">
        <button
          onClick={() => setShowModal(true)}
          className="bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-500 p-[2px] sm:p-[3px] rounded-full animate-pulse-slow hover:scale-105 transition-all"
        >
          <div className="bg-black rounded-full px-4 py-2 sm:px-6 sm:py-3 text-white font-bold text-xs sm:text-sm tracking-wide text-center whitespace-nowrap overflow-hidden text-ellipsis">
            ¡PRÓXIMA FECHA DEL EVENTO!
          </div>
        </button>
      </div>

      {/* MODAL – EVENTO ONLINE (15 NOV 2025) */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center p-2 sm:p-4"
          onClick={() => setShowModal(false)} // cerrar al hacer clic fuera
        >
          <div
            className="relative w-full max-w-lg max-h-[90vh] overflow-y-auto bg-[#0a0a0a] text-white rounded-2xl border-2 border-purple-500 shadow-2xl scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent"
            onClick={(e) => e.stopPropagation()} // evita cerrar al hacer clic dentro
          >
            {/* Botón cerrar */}
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-2 right-2 text-white text-3xl sm:text-2xl font-bold hover:text-red-400 z-50"
            >
              ×
            </button>

            {/* Botón superior Online */}
            <div className="absolute top-2 left-1/2 -translate-x-1/2 bg-white text-black font-bold px-4 py-1 rounded-full shadow-md">
              {ciudades[ciudadSeleccionada].nombre}
            </div>

            {/* Imagen superior */}
            <img
              src={ciudades[ciudadSeleccionada].imagen}
              alt={`Taller Revolución IA para SST - ${ciudades[ciudadSeleccionada].nombre}`}
              className="w-full h-auto object-contain rounded-t-xl"
            />

            {/* Contenido textual */}
            <div className="px-4 py-3 text-center space-y-3">
              <p className="text-white text-sm sm:text-base leading-relaxed">
                🔥 <strong>¡No te pierdas el Taller Revolución IA en SST en {ciudades[ciudadSeleccionada].nombre}!</strong> 🔥
                <br />
                {ciudades[ciudadSeleccionada].descripcion}
              </p>

              <p className="text-white text-sm sm:text-base">
                📅 <strong>{ciudades[ciudadSeleccionada].fecha}</strong>
                <br />
                {ciudades[ciudadSeleccionada].modalidad === "Online"
                  ? "Evento 100% online, accede desde donde estés"
                  : ""}
              </p>

              <p className="text-white text-sm sm:text-base">
                💡 Prepárate para adquirir herramientas prácticas, casos reales y certificación que potenciarán tu carrera.
                <br />
                <strong>¡Inscríbete y lleva tu carrera al siguiente nivel!</strong>
              </p>

              <a
                href="https://revolucion--ia-sst.ernestomora.com/#pricing"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block text-sm sm:text-base border border-cyan-300 text-white px-6 py-2 rounded-full hover:bg-cyan-600 transition font-semibold"
              >
                ¡QUIERO ASISTIR AL EVENTO!
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
